<template>
<section class="multiple-countries">
    <header class="header">
      <div class="header__left">

        <range-year-slider class="rangeSlider" :years="$store.state.defaultYears" startSelection="2021"></range-year-slider>

        <div class="confidence-actions">
          <Checkbox
            class="confidence-actions__checkbox"
            :active="$store.state.confidenceIntervals"
            @toggle="$store.state.confidenceIntervals = !$store.state.confidenceIntervals"
          >{{ this.$Strings('confidenceIntervals') }}</Checkbox>
          <HelpTooltip class="confidence-actions__tooltip" :description="this.$Strings('confidenceIntervalsDescription')"></HelpTooltip>
        </div>
      </div>

      <div class="header__right">
        <div class="multiple-countries__btngroup">
          <ButtonGroup
            class="multiple-countries__btngroup__group"
            :values="{'attributes': this.$Strings('attributes'), 'subattributes': this.$Strings('subattributes') }"
            :selectedKey="attrSub"
            @click="toggleAttrSub()"
          ></ButtonGroup>
        </div>
      </div>
    </header>

    <div class="country-minified--sub">
      <div class="country-minified__item-wrapper" v-if="attrSub === 'attributes'">
        <div class="country-minified__item" v-bind:key="index" v-for="(row, index) in attributeData">
          <div class="barchart">
            <BarLine
              class="barchart__line"
              v-for="(ar, i) in row"
              :key="'attribute' + i"
              :confInt="ar.range"
              :color="ar.value | valueColor"
              :value="parseFloat(ar.value)"
              :tooltip="row.description"
              :label="ar.label"
              :showValues="false"
              :canvasSize="[30,100]"
              :strokeWidth="20"
              :showRange="$store.state.confidenceIntervals"
              :showInLineValue="true"
            ></BarLine>
          </div>
          <div class="country-minified__item__name" v-if="row[0].country">{{ row[0].country }}</div>
        </div>
      </div>

      <div class="country-minified__item-wrapper" v-if="attrSub === 'subattributes'">
        <div class="country-minified__item" v-bind:key="index" v-for="(row, index) in subattributeData">
          <div class="barchart">
            <BarLine
              class="barchart__line"
              v-for="(ar, i) in row"
              :key="'subattribute_' + i"
              :confInt="ar.range"
              :color="ar.value | valueColor"
              :value="parseFloat(ar.value)"
              :tooltip="row.description"
              :label="ar.label"
              :showValues="false"
              :showRange="$store.state.confidenceIntervals"
            ></BarLine>
          </div>
          <div class="country-minified__item__name" v-if="row[0].country">{{ row[0].country }}</div>
        </div>
      </div>
      <HighMediumLowExplainer class="mt-20 explainer" :bg="true"></HighMediumLowExplainer>
    </div>
  </section>
</template>

<script>
// import _ from 'lodash'
import Vue from 'vue'
import {EventBus} from '@/event-bus.js'

import RangeYearSlider from '../../shared/sliders/RangeYearSlider.vue'
import Checkbox from '../../shared/misc/Checkbox.vue'
import HelpTooltip from '../../shared/misc/HelpTooltip.vue'
import ButtonGroup from '../../shared/misc/ButtonGroup.vue'
import BarLine from '../../shared/charts/BarLine.vue'
import HighMediumLowExplainer from '../../shared/misc/HighMediumLowExplainer.vue'

import ChecksOnGovernmentIcon from '@/components/shared/navigation/AttributesNavigation/assets/ChecksOnGovernmentIcon'
import ParticipatoryEngagementIcon from '@/components/shared/navigation/AttributesNavigation/assets/ParticipatoryEngagementIcon'
import RepresentativeGovernmentIcon from '@/components/shared/navigation/AttributesNavigation/assets/RepresentativeGovernmentIcon'
import FundamentalRightsIcon from '@/components/shared/navigation/AttributesNavigation/assets/FundamentalRightsIcon'
import ImpartialAdministrationIcon from '@/components/shared/navigation/AttributesNavigation/assets/ImpartialAdministrationIcon'

export default Vue.extend({
  props: ['subattributeData', 'attributeData'],
  components: {
    HighMediumLowExplainer,
    BarLine,
    RangeYearSlider,
    Checkbox,
    HelpTooltip,
    ButtonGroup,
    ChecksOnGovernmentIcon,
    ParticipatoryEngagementIcon,
    RepresentativeGovernmentIcon,
    FundamentalRightsIcon,
    ImpartialAdministrationIcon
  },
  data () {
    return {
      attrSub: 'attributes'
    }
  },
  watch: {
    attributeData () {
      EventBus.$emit('slider.refresh')
    }
  },
  methods: {
    toggleAttrSub () {
      if (this.attrSub === 'subattributes') {
        this.attrSub = 'attributes'
      } else {
        this.attrSub = 'subattributes'
      }
    }
  }
})
</script>

<style lang="scss" scoped>
  @import '~@/components/sass/shared/colors';
  @import '~@/components/sass/mixins/clearfix';
  @import '~@/components/sass/mixins/flexbox-grid';
  @import '~@/components/sass/components/btns';
  @import '~@/components/sass/shared/helpers';

  .barchart{
    display: flex; -js-display: flex;
    justify-content: space-between;
  }

  .barchart__line{
    flex: 1 1 auto;
  }

  .country-minified{
    @include grid($gutter: 60px, $flex-wrap: wrap)
  }
  .country-minified--sub{}

  .country-minified__item-wrapper{
    @include grid($gutter: 60px, $flex-wrap: wrap);
  }

  .country-minified__item{
    max-width: 175px;
    box-sizing: border-box;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 calc(33.33333% - 60px);
    flex: 0 0 calc(33.33333% - 60px);
    margin: 0 20px 60px;
    text-align: center;
  }
  .country-minified__item__name{
    font-weight: 600;
    margin-top: 20px;
  }

  .multiple-countries .header{
    display: flex; -js-display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
  }
  .multiple-countries .header__left{
    flex: 1 1 auto;
  }
  .multiple-countries .header__right{
    display: flex; -js-display: flex;
    align-items: flex-end;
    flex: 0 0 205px;
    margin-left: 20px;
    width: 205px;
  }
  .multiple-countries .rangeSlider{height: 60px;
    margin: 20px 0 0;
  }

  .multiple-countries .header__right .buttongroup{
    margin-bottom: 80px;
  }

  .multiple-countries__btngroup{
    @include clearfix();
    margin-bottom: 1em;
    margin-top: 1em;
  }
  .multiple-countries__btngroup__group{
    float: right
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/CountriesRegionsProfile/MultipleCountries.vue